import { useCallback } from 'react';

import { useUpdateConsignmentMutation } from '../api/consignmentsApi';
import type { ConsignmentUpdateRequest, ConsignmentUpdateParams } from './types';

export interface UseUpdateConsignmentOptions {
  onSuccess?: (data: unknown) => void;
  onError?: (error: unknown) => void;
}

export const useUpdateConsignment = (options?: UseUpdateConsignmentOptions) => {
  const [updateConsignment, result] = useUpdateConsignmentMutation();

  const handleUpdate = useCallback(
    async (params: ConsignmentUpdateParams, data: ConsignmentUpdateRequest) => {
      try {
        const response = await updateConsignment({
          ...data,
          ...params
        }).unwrap();

        options?.onSuccess?.(response);
        return response;
      } catch (error) {
        options?.onError?.(error);
        throw error;
      }
    },
    [updateConsignment, options]
  );

  return {
    updateConsignment: handleUpdate,
    isLoading: result.isLoading,
    isSuccess: result.isSuccess,
    isError: result.isError,
    error: result.error,
    data: result.data
  };
};
